import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnDestroy {
  showVideoModal = false;
  isPlaying = false;
  currentSlide = 0;
  currentTime = 0;
  playerProgress = 0;
  totalDuration = 16; // 16 seconds video (3s * 4 slides + 4s CTA)

  private playInterval: any;

  openVideo() {
    this.showVideoModal = true;
    this.isPlaying = true;
    this.currentSlide = 0;
    this.currentTime = 0;
    this.playerProgress = 0;
    this.startPlayback();
  }

  closeVideo() {
    this.showVideoModal = false;
    this.isPlaying = false;
    this.stopPlayback();
  }

  togglePlay() {
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.startPlayback();
    } else {
      this.stopPlayback();
    }
  }

  restartVideo() {
    this.currentSlide = 0;
    this.currentTime = 0;
    this.playerProgress = 0;
    this.isPlaying = true;
    this.startPlayback();
  }

  private startPlayback() {
    this.stopPlayback();
    this.playInterval = setInterval(() => {
      if (this.currentTime < this.totalDuration) {
        this.currentTime++;
        this.playerProgress = (this.currentTime / this.totalDuration) * 100;
        
        // Update slides based on time
        if (this.currentTime < 3) {
          this.currentSlide = 0;
        } else if (this.currentTime < 6) {
          this.currentSlide = 1;
        } else if (this.currentTime < 9) {
          this.currentSlide = 2;
        } else if (this.currentTime < 12) {
          this.currentSlide = 3;
        } else {
          this.currentSlide = 4;
        }
      } else {
        this.isPlaying = false;
        this.stopPlayback();
      }
    }, 1000);
  }

  private stopPlayback() {
    if (this.playInterval) {
      clearInterval(this.playInterval);
      this.playInterval = null;
    }
  }

  ngOnDestroy() {
    this.stopPlayback();
  }
}

